import { Component, Input, OnInit, OnDestroy, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { UtilitiesProvider } from '../../providers/utilities';
import { CatalogData } from '../../providers/catalog';
import { PaymentProvider } from '../../providers/payment';
import * as fromAuth from '../../ngrx/reducers/auth.reducer';
import { Store } from '@ngrx/store';
import { ENV } from "@app/env";
import { Subscription } from 'rxjs';
import { has } from 'lodash';
import { Platform, NavParams } from 'ionic-angular';
import { AnalyticsData, _ACTIONS } from '../../providers/analytics';
import { DetailShoppingCartHelperComponent } from '../../components/detail-shopping-cart-helper/detail-shopping-cart-helper';
import { TrackingData, _TRACKING_ENTITIES, _TRACKING_ACTIONS } from '../../providers/tracking';

const componentName = 'ControlQuantityProductComponent';

@Component({
  selector: 'app-control-quantity-product',
  templateUrl: 'control-quantity-product.html'
})
export class ControlQuantityProductComponent implements OnInit, OnDestroy {

  @Input() catalogId: string;
  @Input() catalog: any;
  @Input() origin: 'product' | 'shoppingCart';
  @Input() config: any;
  @Input() uidTrack: string;
  @Output() onChangeFlag = new EventEmitter();
  public btnSlack = document.getElementById("slaask-helper");

  @ViewChild(DetailShoppingCartHelperComponent) DetailShoppingCartHelperComponent: DetailShoppingCartHelperComponent;

  public loaderButton: boolean = false;
  public modelAmount: number;
  public amount: number;
  public catalogInfo: any;
  public selectOptions: any;
  private userSub: Subscription;
  private shoppingSub: Subscription;
  private shoppingCartUser: any = null;
  private userInfo: any;

  constructor(
    private utilities: UtilitiesProvider,
    private catalogProvider: CatalogData,
    private trackingData: TrackingData,
    private paymentProvider: PaymentProvider,
    private store: Store<any>,
    private platform: Platform,
    private analytics: AnalyticsData,
    public navParams: NavParams
  ) { }

  ngOnInit() {
    this.calculateSelectOptions();
    this.firstLoadProduct();
  }

  /**
   * Hace la validacion inicial del producto
   * 1. Valida que el producto exista basado en el id ingresado
   * 2. Se valida que el producto encontrado este activo
   * 3. Si el origen es un carrito de compra se valida que exista en el carrito de compra
   */
  private firstLoadProduct() {
    this.catalogProvider.getCatalogSnapById(ENV.client, this.catalogId)
      .then(catalog => {
        if (!catalog.val()) {
          return this.presentAlert('The product has not been found!');
        }
        if (!catalog.val().state) {
          return this.presentAlert('The product has not been found!');
        }

        this.catalogInfo = catalog.val();
        this.validateShoppingCart();
      })
      .catch(() => {
        return this.presentAlert('An error has been presented looking for the product!');
      })
  }

  public async calculateSelectOptions() {
    this.selectOptions = {
      title: await this.utilities.translateTextOrObject('Amount selection:')
    }
  }
  /**
   * Hace la validacion de existencia del carrito de compra
   * 1. Se carga el usuario actual y se valida si existe
   * 2. Se carga el carrito de compra del usuario
   * 3. Se valida si el origin es shoppingCart y existe un carrito de compra
   * 4. Si el origin es shoppingCart se valida el producto exista en el carrito de compra
   */
  private validateShoppingCart() {
    this.userSub = this.store.select(fromAuth.getUser)
      .subscribe(user => {
        if (user) {
          this.shoppingSub = this.catalogProvider.getUserShoppingCart(ENV.client, user.info.id)
            .subscribe((shoppingCart: any) => {
              this.userInfo = user;
              this.shoppingCartUser = shoppingCart;

              if (this.origin === 'shoppingCart') {
                if (has(this.shoppingCartUser, 'products')) {
                  return Object.keys(this.shoppingCartUser.products).map(key => {
                    if (this.shoppingCartUser.products[key].id === this.catalogId) {
                      this.amount = this.shoppingCartUser.products[key].sale_amount;
                      this.modelAmount = this.shoppingCartUser.products[key].sale_amount;
                      return true;
                    }
                  });
                }
              } else {
                this.amount = 1;
                this.modelAmount = 1;
                return true;
              }
            });
        }
      });
  }

  /**
   * Calcula la interfaz a mostrar segun el dispositivo
   */
  public get amountChangeInterface() {
    if (this.platform.is('mobile')) {
      return 'action-sheet';
    }
    return 'popover';
  }

  /**
   * Se ejecuta cuando se selecciona una opcion en el select
   * @param newAmount
   */
  public selectAmount(newAmount) {
    if (!newAmount) {
      return this.manualChange();
    } else {
      return this.changeValue(newAmount);
    }
  }

  /**
   * Genera el arreglo de las opciones a seleccionar en amount
   */
  public generateMaxAmount() {
    const max = this.catalogInfo.maximum_amount_purchase > 10 ? 10 : this.catalogInfo.maximum_amount_purchase;
    const obj = [];
    for (let i = 1; i <= max; i++) {
      obj.push(i);
    }
    return obj;
  }

  /**
   * Cambio manual de cantidad de producto
   */
  public async manualChange() {
    this.utilities.alert.create({
      title: await this.utilities.translateTextOrObject('Amount update'),
      message: await this.utilities.translateTextOrObject('Enter the new amount'),
      inputs: [{
        type: 'number',
        name: 'new_amount',
        label: await this.utilities.translateTextOrObject('New amount')
      }],
      buttons: [{
        text: await this.utilities.translateTextOrObject('Cancel'),
        role: 'cancel',
        handler: () => {
          this.modelAmount = this.amount;
        }
      }, {
        text: await this.utilities.translateTextOrObject('Send'),
        handler: data => {
          if (parseInt(data.new_amount) > 0) {
            this.changeValue(parseInt(data.new_amount));
          } else {
            return false;
          }
        }
      }]
    }).present();
  }

  /**
   * Validacion de cambio de valor
   * 1. Si es origin producto se valida que la capacidad maxima no sea superada
   * 2. Si es origin shopping cart
   * @param newValue
   */
  public changeValue(newValue: number) {
    if (newValue <= this.catalogInfo.maximum_amount_purchase) {
      if (newValue <= this.catalogInfo.stock) {
        if (this.origin === 'product') {
          this.modelAmount = newValue;
          return this.amount = newValue;
        } else if (this.origin === 'shoppingCart') {
          return this.addToCart(newValue);
        }
      } else {
        if (this.origin === 'product') {
          this.modelAmount = 1;
        } else if (this.origin === 'shoppingCart') {
          this.modelAmount = this.amount;
        }
        return this.presentToast('The required value is not available in the stock!');
      }
    } else {
      if (this.origin === 'product') {
        this.modelAmount = 1;
      } else if (this.origin === 'shoppingCart') {
        this.modelAmount = this.amount;
      }

      return this.presentToast('The maximum amount allowed is', 4000, 'bottom', this.catalogInfo.maximum_amount_purchase);
    }
  }

  /**
   * Se hacen todas las validaciones y de pasar se agrega al carrito de compra
   * 1. Se valida disponibilidad si el origin es shoppingCart ya que se valida directamente con el producto
   */
  public addToCart(newValue: number = null) {
    if (this.origin === 'product') {
      this.loaderButton = true;
      let productShoppingCart = null;
      if (has(this.shoppingCartUser, 'products')) {
        Object.keys(this.shoppingCartUser.products).map(key => {
          if (this.shoppingCartUser.products[key].id === this.catalogId) {
            productShoppingCart = this.shoppingCartUser.products[key];
          }
        });
      }

      if (productShoppingCart) {
        if (this.catalogInfo.maximum_amount_purchase < (this.modelAmount + productShoppingCart.sale_amount)) {
          this.modelAmount = 1;
          return this.presentToast('The maximum amount allowed is', 4000, 'bottom', this.catalogInfo.maximum_amount_purchase);
        }
        if (this.catalogInfo.stock < (this.modelAmount + productShoppingCart.sale_amount)) {
          this.modelAmount = 1;
          return this.presentToast('The required value is not available in the stock!');
        }

        return this.addProductAmount(this.modelAmount + productShoppingCart.sale_amount);

      }
      return this.addProductAmount(this.modelAmount);
    }

    if (this.origin === 'shoppingCart') {
      this.loaderButton = true;
      let productShoppingCart = null;
      if (has(this.shoppingCartUser, 'products')) {
        Object.keys(this.shoppingCartUser.products).map(key => {
          if (this.shoppingCartUser.products[key].id === this.catalogId) {
            productShoppingCart = this.shoppingCartUser.products[key];
          }
        });
      } else {
        return this.presentAlert('The product has not been found!');
      }

      if (productShoppingCart) {
        if (this.catalogInfo.maximum_amount_purchase < newValue) {
          this.modelAmount = this.amount;
          return this.presentToast('The maximum amount allowed is', 4000, 'bottom', this.catalogInfo.maximum_amount_purchase);
        }
        return this.addProductAmount(newValue);
      } else {
        this.modelAmount = this.amount;
        return this.presentAlert(`The user's shopping cart was not found!`);
      }

    }
  }

  /**
   * Paso final adicionar/actualizar producto al carrito de compra
   * @param newAmount
   */
  private addProductAmount(newAmount: number) {
    const actualAmount = this.amount;
    this.paymentProvider.addProductToShoppingCart(this.userInfo.info.id, this.catalogInfo, newAmount)
      .then(() => {
        this.amount = newAmount;
        this.modelAmount = newAmount;
        // this.btnSlack.setAttribute("style", "display:none;");
        this.onChangeFlag.emit(true);
        //Sólo presenta el toast si la cantidad cambió
        return (actualAmount !== this.amount) ?
          this.presentToast('The product has been added to the shopping cart!', 3000, 'top') :
          this.loaderButton = false;
      })
      .then(() => {
        //Trancking addProduct to Cart
        this.trackingData.trackActivity(this.userInfo.info.id, _TRACKING_ENTITIES.CATALOG, this.catalogInfo.id, ENV.client, _TRACKING_ACTIONS.ADD_TO_CART);
        this.analytics.savePageTrackOnFirestore(
          componentName,
          _ACTIONS.updateProductCart,
          this.uidTrack,
          { catalogId: this.catalogInfo.id, amount: newAmount }
        );
        return;
      })
      .catch(err => {
        this.modelAmount = this.amount;
        this.utilities.consoleErrorAll('error on addProductAmount', err)
        this.loaderButton = false;
      });
  }

  /**
   * Presenta mensaje tipo toast
   * @param message
   * @param duration
   * @param position
   * @param addTextMessage
   */
  private presentToast(message: string, duration = 4000, position = 'bottom', addTextMessage: string = null): Promise<any> {
    let newMessage = message;
    newMessage += addTextMessage ? ` ${addTextMessage}` : '';

    return this.utilities.setToast(newMessage, duration, position).then(() => {
      this.loaderButton = false;
    });
  }

  /**
   * Presenta mensaje tipo Alert
   * @param message
   * @param title
   */
  private presentAlert(message: string, title: string = 'Alert') {
    return this.utilities.presentAlert(
      title,
      message,
      [{
        text: 'Ok',
        role: 'cancel',
        handler: () => {
          this.loaderButton = false;
        }
      }]
    );
  }

  ngOnDestroy() {
    if (this.shoppingSub) this.shoppingSub.unsubscribe();
    if (this.userSub) this.userSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/control-quantity-product/control-quantity-product.ts